import { Component, Input } from '@angular/core';
import { Note } from 'app/core/models/note.model';
import { DatePipe } from '@angular/common';
import { SafeHtmlPipe } from '../../pipes/safe-html.pipe';

@Component({
    selector: 'app-note',
    templateUrl: './note.component.html',
    styleUrls: ['./note.component.scss'],
    imports: [DatePipe, SafeHtmlPipe]
})
export class NoteComponent {
  @Input() note: Note;
}
